import { Modal } from "risa-oasis-ui_v2";
import WarningIcon from "../../../svg/warningIcon";

interface SendToPlanConfirmModalProps {
  onClose: () => void;
  onSaveClick: () => void;
}

const SendToPlanConfirmModal = (props: SendToPlanConfirmModalProps) => {
  const onSaveClick = () => {
    props.onSaveClick();
    props.onClose();
  };
  return (
    <Modal
      dialogId="send-to-plan-confirm-modal"
      title="Submission Confirmation"
      saveButtonText="Yes, Submit"
      cancelText="Cancel"
      onSave={onSaveClick}
      onCancel={props.onClose}
      onClose={props.onClose}
    >
      <div className="send-to-plan-modal--container flex flex-col items-center justify-center gap-3">
        <div className="send-to-plan-modal--icon">
          <WarningIcon />
        </div>
        <div className="send-to-plan--main-text text-primaryGray3 text-center text-h12 font-normal">
          The details in the form <strong>can’t be edited</strong> after
          submitting the form. <br /> Are you sure you want to submit ?
        </div>
      </div>
    </Modal>
  );
};

export default SendToPlanConfirmModal;
